<template>
  <div>
    <dl-form
      ref='refForm'
      :formAttributeArr="formAttributeArr"
    >
      <template v-slot:formItem>
        <el-button
          class="w100"
          type="primary"
          round
          @click="handleNext"
        >下一步</el-button>
      </template>
    </dl-form>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {

  components: {
  },
  props: {
    currentStep: Number,
    preFormData: Object,
  },
  data () {
    const validatePass = (rule, value, callback) => {
      const { password } = this.$refs.refForm.formData
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== password) {
        callback(new Error('两次密码不一致'))
      } else {
        callback()
      }
    }
    return {
      formAttributeArr: [
        {
          type: 'input',
          keyName: 'password',
          formItem: {
            label: '新密码',
            rules: {required: true}
          },
          compAttrs: {
            showPassword: true,
          }
        },
        {
          type: 'input',
          keyName: 'password1',
          formItem: {
            label: '确认密码',
            rules: [{ required: true, validator: validatePass, trigger: 'blur' }]
          },
          compAttrs: {
            showPassword: true,
          }
        },
      ]
    }
  },
  computed: {},
  methods: {
    async handleNext() {
      const { data } = this.$refs.refForm.validate()
      if (data) {
        const { phone, verify_code, password } = {...data, ...this.preFormData}
        request({
          method: 'POST',
          url: '/api/site/set_password_by_phone',
          data: { phone, verify_code, password },
        }).then(() => {
          this.$emit('goNext')
        })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
</style>